export const VIEW_USER_MANAGEMENT = 'VIEW_USER_MANAGEMENT'
export const VIEW_LICENSE_MANAGEMENT = 'VIEW_LICENSE_MANAGEMENT'
export const CREATE_TEXTBOOK = 'CREATE_TEXTBOOK'
export const EDIT_TEXTBOOK = 'EDIT_TEXTBOOK'
export const DELETE_TEXTBOOK = 'DELETE_TEXTBOOK'
export const CREATE_TEXTBOOK_ISSUE = 'CREATE_TEXTBOOK_ISSUE'
export const EDIT_TEXTBOOK_ISSUE = 'EDIT_TEXTBOOK_ISSUE'
export const DELETE_TEXTBOOK_ISSUE = 'DELETE_TEXTBOOK_ISSUE'
export const IMPORT_TEXTBOOK_ISSUE = 'IMPORT_TEXTBOOK_ISSUE'
export const UPLOAD_MEDIA_ITEM = 'UPLOAD_MEDIA_ITEM'
export const EDIT_MEDIA_ITEM = 'EDIT_MEDIA_ITEM'
export const DELETE_MEDIA_ITEM = 'DELETE_MEDIA_ITEM'
export const CREATE_MEDIA_ITEM_OCCURENCE = 'CREATE_MEDIA_ITEM_OCCURENCE'
export const EDIT_MEDIA_ITEM_OCCURENCE = 'EDIT_MEDIA_ITEM_OCCURENCE'
export const DELETE_MEDIA_ITEM_OCCURENCE = 'DELETE_MEDIA_ITEM_OCCURENCE'
export const REORDER_MEDIA_ITEM_OCCURENCES = 'REORDER_MEDIA_ITEM_OCCURENCES'
export const CREATE_CATEGORY = 'CREATE_CATEGORY'
export const EDIT_CATEGORY = 'EDIT_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const REORDER_CATEGORIES = 'REORDER_CATEGORIES'
export const PUBLISH_TEXTBOOK_ISSUE_LIVE = 'PUBLISH_TEXTBOOK_ISSUE_LIVE'
export const PUBLISH_TEXTBOOK_ISSUE_PREVIEW = 'PUBLISH_TEXTBOOK_ISSUE_PREVIEW'
export const PREVIEW_TEXTBOOK_ISSUE = 'PREVIEW_TEXTBOOK_ISSUE'
export const CREATE_VOLUME = 'CREATE_VOLUME'
export const EDIT_VOLUME = 'EDIT_VOLUME'
export const DELETE_VOLUME = 'DELETE_VOLUME'
